import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { ServerStatusService } from './core/services/server-status.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  connectionLost$ = this.serverStatusService.connectionLost$;

  constructor(private title: Title, private serverStatusService: ServerStatusService) {
    this.title.setTitle(environment.project.name);
  }
  ngOnInit() {
  }
}
